module.exports = __webpack_public_path__ + "img/loading.b3daa73f.gif";